export default __webpack_public_path__ + "static/designCrm-e5a96e6438f216dbf10b434c0b026719.png";